import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["tabindex", "aria-labelledby"]
const _hoisted_2 = ["id", "src", "alt"]
const _hoisted_3 = { class: "bg-poppy rounded-b-xl px-3 xl:px-4 py-2 xl:py-3 grow w-full" }
const _hoisted_4 = { class: "text-left w-full flex flex-row gap-1 xl:items-start" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "text-bodyXxs xl:text-bodyMd 2xl:text-bodyXl text-slateGray opacity-70" }

import { computed } from 'vue'
import RightArrowCircleIcon from '@/assets/svg/RightArrowCircleIcon.vue'
import useImageLoad from '@/composables/useImageLoad'
import { ButtonPanelSizing } from './types'

interface Props {
  identifier?: string
  image: string
  altText?: string
  title: string
  subtitle: string
  sizing: ButtonPanelSizing
  tabIndex?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PanelButton',
  props: {
    identifier: null,
    image: null,
    altText: null,
    title: null,
    subtitle: null,
    sizing: null,
    tabIndex: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', event: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  identifier?: string
  image: string
  altText?: string
  title: string
  subtitle: string
  sizing: ButtonPanelSizing
  tabIndex?: number
}





const handleClick = (evt) => {
  emit('click', evt)
}

const buttonPanelWidthClasses = computed(() => {
  switch (props.sizing) {
    case ButtonPanelSizing.Large:
      return 'max-w-[230px] xl:max-w-[430px] 2xl:max-w-[540px]'
    default:
      return 'max-w-[320px] 2xl:max-w-[450px]'
  }
})

const buttonPanelHeightClasses = computed(() => {
  switch (props.sizing) {
    case ButtonPanelSizing.Large:
      return 'h-[100px] md:h-[140px] xl:h-[240px] 2xl:h-300px'
    default:
      return 'h-[80px] xl:h-[140px] 2xl:h-200px'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    tabindex: props.tabIndex,
    onClick: handleClick,
    class: _normalizeClass(["text-left pointer-events-auto flex flex-col", _unref(buttonPanelWidthClasses)]),
    "aria-labelledby": props.identifier + '-label'
  }, [
    _createElementVNode("img", {
      id: props.identifier + '-panelBtn-img',
      class: _normalizeClass(["rounded-t-xl object-cover w-full", _unref(buttonPanelHeightClasses)]),
      src: `/images/${props.image}`,
      onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(useImageLoad) && _unref(useImageLoad)(...args))),
      alt: props.altText
    }, null, 42, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          id: props.identifier + '-label',
          class: "font-serif text-headingXs xl:text-headingSm 2xl:text-headingMd grow text-black"
        }, _toDisplayString(props.title), 9, _hoisted_5),
        _createVNode(RightArrowCircleIcon, { class: "w-6 xl:w-8 2xl:w-[37px] h-[18px] xl:h-[26px] 2xl:h-[38px] text-[#0F172A]" })
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(props.subtitle), 1)
    ])
  ], 10, _hoisted_1))
}
}

})